import React, { useState, useEffect, useCallback } from 'react';
import { Row } from 'react-bootstrap';
import HVASpinner from 'components/base/HVASpinner';
import ScoreEvolutionChart from 'components/charts/QAScoreEvolutionChart';
import { fetchHVAScorecardDashEvolutionData } from 'services/hvaqa.service';
import QAScorecardData3 from './QADashboardScorecardData3';

interface QAScorecardData2Props {
  scorecardid: number;
  startdate: Date;
  enddate: Date;
  serviceid: number;
  campaignid: number;
  agentid: number;
}

const QAScorecardData2: React.FC<QAScorecardData2Props> = ({
  scorecardid,
  startdate,
  enddate,
  serviceid,
  campaignid,
  agentid
}) => {
  // eslint-disable-next-line
  const [evolutionData, setEvolutionData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  // Función para obtener los datos
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetchHVAScorecardDashEvolutionData({
        scorecardid,
        serviceid,
        campaignid,
        agentid,
        datefrom: startdate,
        dateto: enddate
      });
      setEvolutionData(response);
    } catch (err) {
      console.error('Error al recuperar los datos del scorecard: ', err);
    } finally {
      setLoading(false);
    }
  }, [scorecardid, startdate, enddate, serviceid, campaignid, agentid]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {loading ? (
        <Row className="justify-content-center align-items-center pt-3 w-100">
          <HVASpinner />
        </Row>
      ) : (
        <>
          <Row className="mb-1 mx-n3 px-0 pt-1 justify-content-start align-items-center">
            <h4>Score value evolution</h4>
            <p className="fs-9 mb-0">
              Daily average score and volume of calls analized.
            </p>
            {evolutionData && <ScoreEvolutionChart data={evolutionData} />}
          </Row>
          <Row className="mb-1 mx-0 p-0 pt-3 justify-content-start align-items-center">
            <div className="px-0 mx-0">
              <QAScorecardData3
                scorecardid={scorecardid}
                startdate={startdate}
                enddate={enddate}
                serviceid={serviceid}
                campaignid={campaignid}
                agentid={agentid}
              />
            </div>
          </Row>
        </>
      )}
    </>
  );
};

export default React.memo(QAScorecardData2);
